/**
 * 简化版本：直接将custom_dimensions平铺到外层对象
 * @param {Object} apiData - 接口返回的原始数据
 * @returns {Object} - 处理后的数据
 */
export function flattenCustomDimensions(apiData) {
  if (!apiData?.metrics_list?.length) return apiData;
  
  const result = apiData;
  result.metrics_list = result?.metrics_list?.map(item => {
    if (!item.custom_dimensions?.length) return item;
    
    // 遍历custom_dimensions并平铺到外层
    item.custom_dimensions.forEach(customDim => {
      if (customDim.key && customDim.value !== undefined) {
        // 直接添加到外层
        item[customDim.key] = customDim?.value;
        item[`${customDim.key}_name`] = customDim?.name_en || customDim?.name_ch;

      }
    });
    
    return item;
  });
  
  return result;
}